module.exports = __webpack_public_path__ + "static/media/icon_system_setting.c8a509ff.svg";